import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const phone = "919211974059";
  const message = encodeURIComponent("Hello DeepRoots Spice, I would like to enquire about your export offerings.");
  return (
    <a
      href={`https://wa.me/${phone}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-brand-green/30 animate-ping" />
      <span className="relative w-14 h-14 flex items-center justify-center rounded-full bg-brand-green text-brand-ivory shadow-2xl border border-brand-gold/50 group-hover:bg-brand-green-deep transition-colors">
        <MessageCircle className="w-6 h-6" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-brand-ink text-brand-ivory text-[11px] tracking-[0.2em] uppercase px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us
      </span>
    </a>
  );
}
